<div class="radial-progress" style="--percentage: {{percent}};">
            <span class="percentage-text">{{percent}}%</span>
        </div>

      <style>
            /* The main radial progress bar element */
        .radial-progress {
            /* Define CSS variables for easy customization */
            /* Use clamp() for a responsive size: min-size, preferred-size (viewport relative), max-size */
            --size: clamp(50px, 50px, 50px); /* Adjusted for better responsiveness */
            --line-width: calc(var(--size) * 0.19); /* Line width relative to the overall size */

            --percentage: 0; /* Default percentage value (0-100) */
            --progress-color: #fa4b1b; /* Vibrant purple for the progress */
            --track-color: #e0e0e0; /* Light gray for the background track */
            --inner-bg-color: #ffffff; /* Background color for the inner circle (donut hole) */


            position: relative;
            width: var(--size);
            height: var(--size);
            border-radius: 50%; /* Makes the element circular */
            display: grid; /* Use grid for easy centering of the text */
            place-items: center; /* Centers content (the percentage text) horizontally and vertically */
            overflow: hidden; /* Ensures nothing spills outside the circle */

            /* This is the core CSS for the donut chart effect */
            background:
                /* Inner circle (the "hole" of the donut) */
                radial-gradient(closest-side, var(--inner-bg-color) calc(100% - var(--line-width)), transparent calc(100% - var(--line-width) + 1px) 100%),
                /* Conic gradient for the progress and track */
                conic-gradient(var(--progress-color) calc(var(--percentage) * 1%), var(--track-color) 0deg);

            /* Smooth transition for percentage changes */
            transition: background 0.5s ease-in-out;
            /* Add a slight shadow for depth */
            box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.05);
        }

        /* Styling for the percentage text in the middle */
        .percentage-text {
            font-size: calc(var(--size) * 0.2); /* Make font size relative to the progress bar's size */
            font-weight: 700; /* Bold text */
            color: #333; /* Dark gray color */
            pointer-events: none; /* Allows clicks to pass through if needed */
            /* No need for absolute positioning here due to parent's `display: grid` and `place-items: center` */
        }
            </style>
